import React, { useState } from 'react';
import './MedicoPhoto.css';

function hasPhotoUrl(url) {
  return typeof url === 'string' && url.trim().length > 0;
}

function initialsFromAlt(alt) {
  const parts = String(alt || '')
    .replace(/^Dott\.?\s*ssa?\s*/i, '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

/**
 * Foto medico: aspect fisso, width/height, iniziali se assente (mai spinner infinito).
 * @param {'card'|'detail'|'thumb'} variant
 */
const MedicoPhoto = ({
  src,
  alt = '',
  variant = 'card',
  className = '',
  width,
  height,
}) => {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !hasPhotoUrl(src) || failed;
  const size = variant === 'detail' ? 120 : variant === 'thumb' ? 48 : 72;
  const w = width || size;
  const h = height || size;
  const rootClass = [
    'medico-photo',
    `medico-photo--${variant}`,
    showPlaceholder ? 'medico-photo--placeholder' : '',
    className,
  ].filter(Boolean).join(' ');

  if (showPlaceholder) {
    return (
      <div
        className={rootClass}
        role={alt ? 'img' : undefined}
        aria-label={alt || undefined}
        style={{ width: w, height: h, minWidth: w, minHeight: h }}
      >
        <span className="medico-photo__initials" aria-hidden="true">
          {initialsFromAlt(alt)}
        </span>
      </div>
    );
  }

  return (
    <div className={rootClass} style={{ width: w, height: h, minWidth: w, minHeight: h }}>
      <img
        src={src.trim()}
        alt={alt}
        width={w}
        height={h}
        loading="lazy"
        decoding="async"
        sizes={variant === 'card' ? '(max-width: 640px) 100vw, 320px' : undefined}
        onError={() => setFailed(true)}
      />
    </div>
  );
};

export default MedicoPhoto;
